module.exports = __webpack_public_path__ + "media/src/img/payment/image3-f01af8cb34934e738111334e2716dfb7.png";